<header>
  <div class="container">
    <div class="welcome">
      <h3>
        {{ 'profile.hello' | translate }} <strong>{{ userName | titlecase }}</strong> !
      </h3>
      <button class="btn editButton" (click)="openDialog()">
        {{ 'profile.edit_account' | translate }}
      </button>
    </div>
  </div>
</header>
<section>
  <div class="container">
    <mat-tab-group>
      <mat-tab [label]="'profile.tab.personal' | translate">
        <section class="tab2">
          <div>
            <h1>{{ 'profile.personal_info' | translate }}</h1>
            <h3>{{ fullName }}</h3>
            <div class="d-f-tab2">
              <div>
                <p class="suptitle">{{ 'profile.place' | translate }}</p>
                <p>{{ city }}</p>
              </div>
              <div>
                <p class="suptitle">{{ 'profile.mobile' | translate }}</p>
                <p>{{ mobileNumber }}</p>
              </div>
            </div>
            <button class="btn editInfo" (click)="openDialog()">
              {{ 'profile.edit_personal' | translate }}
            </button>
          </div>
          <hr />
          <div>
            <h1>{{ 'profile.login_info' | translate }}</h1>
            <div class="d-f-tab2">
              <div>
                <p class="suptitle">{{ 'profile.email' | translate }}</p>
                <p>{{ email }}</p>
              </div>
              <div>
                <p class="suptitle">{{ 'profile.username' | translate }}</p>
                <p>{{ userName }}</p>
              </div>
            </div>
          </div>
          <hr />
          <div style="margin-bottom: 10px">
            <h1>{{ 'profile.more_info' | translate }}</h1>
            <div class="d-f-tab2">
              <div>
                <p class="suptitle">{{ 'profile.best_surprise' | translate }}</p>
                <p>{{ best_surprise }}</p>
              </div>
              <div>
                <p class="suptitle">{{ 'profile.fav_color' | translate }}</p>
                <p>{{ favColor }}</p>
              </div>
            </div>
            <div class="d-f-tab2">
              <div>
                <p class="suptitle">{{ 'profile.marital_status' | translate }}</p>
                <p>{{ marital_status }}</p>
              </div>
              <div>
                <p class="suptitle">{{ 'profile.goals' | translate }}</p>
                <p>{{ Ultimate_goals }}</p>
              </div>
            </div>
            <button class="btn editInfo" (click)="editMoreInfo()">
              {{ 'profile.edit_more' | translate }}
            </button>
          </div>
        </section>
      </mat-tab>

      <mat-tab [label]="'profile.tab.orders' | translate">
        <div class="main">
          <h1>{{ 'profile.history' | translate }}</h1>
          <div class="cardStyle" *ngFor="let item of orders">
            <div class="order-header-row">
              <p class="title">{{ 'profile.order_sent' | translate }}</p>
              <span class="order-status-chip" [ngClass]="getOrderStatusClass(item)">
                {{ getOrderStatus(item) | translate }}
              </span>
            </div>
            <div class="row">
              <div class="col-12 col-md-4">
                <div class="d-f">
                  <div>
                    <strong class="suptitle">{{ 'profile.order_number' | translate }}</strong>
                    <p>#{{ item.id }}</p>
                  </div>
                  <div>
                    <strong class="suptitle">{{ 'profile.date_order' | translate }}</strong>
                    <p>{{ item.issue_date | date : "yyyy/MM/dd" }}</p>
                  </div>
                </div>
                <div class="d-f">
                  <div>
                    <strong class="suptitle">{{ 'profile.payment' | translate }}</strong>
                    <p *ngIf="item.cashed == true">{{ 'profile.cod' | translate }}</p>
                    <p *ngIf="item.cashed == false">{{ 'profile.vodafone' | translate }}</p>
                  </div>
                  <div>
                    <strong class="suptitle">{{ 'profile.total' | translate }}</strong>
                    <p>{{ item.total_price }} LE</p>
                  </div>
                </div>
                <div class="d-f">
                  <div>
                    <strong class="suptitle">{{ 'profile.paid' | translate }}</strong>
                    <p *ngIf="item.paid == null">{{ 'profile.no' | translate }}</p>
                    <p *ngIf="item.paid != null">{{ 'profile.yes' | translate }}</p>
                  </div>
                  <div>
                    <strong class="suptitle">{{ 'profile.expected' | translate }}</strong>
                    <p>{{ item.expected_arrival | date : "yyyy/MM/dd" }}</p>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-5 offset-md-1">
                <div>
                  <strong>{{ 'profile.total_items' | translate }} ({{ item.OrdersProducts.length + item.packages.length }})</strong>
                  <div>
                    <table>
                      <thead *ngIf="item?.OrdersProducts.length">
                        <tr>
                          <th>{{ 'profile.col.image' | translate }}</th>
                          <th>{{ 'profile.col.product' | translate }}</th>
                          <th>{{ 'profile.col.qty' | translate }}</th>
                          <th>{{ 'profile.col.price' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let product of item?.OrdersProducts">
                          <td>
                            <img [src]="product.ordersproducts.images[0].image" />
                          </td>
                          <td>{{ product?.ordersproducts?.name }}</td>
                          <td>{{ product?.ammount }}</td>
                          <td class="itemPrice">{{ product?.ordersproducts?.price }} LE</td>
                        </tr>
                      </tbody>

                      <thead *ngIf="item?.packages.length">
                        <tr>
                          <th colspan="2">{{ 'profile.col.package' | translate }}</th>
                          <th>{{ 'profile.col.no_products' | translate }}</th>
                          <th>{{ 'profile.col.price' | translate }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let product of item?.packages">
                          <td colspan="2">{{ product?.name }}</td>
                          <td>{{ product?.quantities }}</td>
                          <td class="itemPrice">{{ product?.total_price }} LE</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <button
              class="btn btn-primary cancel mr-2"
              (click)="openDialogCancel(item.id)"
              *ngIf="!item.cancelled && !item.delivered"
            >
              {{ 'profile.cancel_order' | translate }}
            </button>
            <button
              class="btn btn-primary editOrder mr-2"
              (click)="openDialogEdit(item?.id)"
              *ngIf="!item.cancelled && !item.delivered"
            >
              {{ 'profile.edit_order' | translate }}
            </button>
          </div>
        </div>
      </mat-tab>

      <mat-tab [label]="'profile.tab.requests' | translate">
        <div class="cardStyle" *ngFor="let item of order_request">
          <p class="title">{{ 'profile.order_request' | translate }}</p>
          <div class="row">
            <div class="col-12 col-md-4">
              <div class="d-f">
                <div>
                  <p class="suptitle">{{ 'profile.order_number' | translate }}</p>
                  <p>#{{ item.id }}</p>
                </div>
                <div>
                  <p class="suptitle">{{ 'profile.date_order' | translate }}</p>
                  <p>{{ item.requested_date | date : "yyyy/MM/dd" }}</p>
                </div>
              </div>
              <div class="">
                <div>
                  <p class="suptitle">{{ 'profile.name' | translate }}</p>
                  <p>{{ item.name }}</p>
                </div>
                <div>
                  <p class="suptitle">{{ 'profile.url' | translate }}</p>
                  <p class="text-truncate">
                    <a target="_blank" href="{{ item.URL }}">{{ item.URL }}</a>
                  </p>
                </div>
              </div>
            </div>
            <div class="col-12 col-md-5 offset-md-1">
              <div>
                <div *ngFor="let img of item?.images">
                  <img [src]="img?.image" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <p *ngIf="order_request.length == 0">{{ 'profile.no_product' | translate }}</p>
      </mat-tab>
    </mat-tab-group>
  </div>
</section>

